module.exports = __webpack_public_path__ + "static/media/portfolio1.f5f33824.jpg";